import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';



class BrandFilter extends Component {
    state = {
        brandLists:[],
        brandValue:'',
    };
    componentDidMount(){
        this._getBrand(this.props.start_date,this.props.end_date);
    }

     _getBrand(start_date,end_date){
        this.setState({
                 brandLists:[],
                 brandValue:[],

             })
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-brand/',{
                yestSend:start_date,
                todSend:end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((brand, index) => {
                    this.state.brandLists.push({value: brand.brand, label: brand.brand})
                });
            }
        });
    }
    changeBrand(optionSelected){
        let value='';
        let brandArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                brandArray.push(mids.value)
//                 var index = this.state.brandLists.findIndex(obj => obj.value==mids.value);
//                 this.state.brandLists.move(index,0).join(',');
            });
        }
        this.props.onSelectBrand(optionSelected,brandArray);
        this.setState({
            brandValue:optionSelected,
        });
    }

    render() {

        return (
            <ReactMultiSelectCheckboxes name="brand"
            isMulti
            value={this.state.brandValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeBrand.bind(this)}
            options={this.state.brandLists}
            placeholderButtonLabel="Select [Brand]"
            />
        );

    }
}
export default BrandFilter;